import { basicAccountInfo } from "api/basic_account_info";
import { generic_get_api } from "api/generic_api";
import left_line from 'assets/reputation/left-line.svg';
import middle_line from 'assets/reputation/middle-line.svg';
import right_line from 'assets/reputation/right-line.svg';
import { Component, useState, useEffect } from "react";
import { Placeholder} from 'react-bootstrap';
import { OAK_PLANNING_DETAIL } from 'utils/constants';
import { EventNames, trackEvent } from 'utils/mixpanel';


class OakPlanningDetail extends Component {
    
    constructor(props) {
        
        let record_id = null;
        let path_components = window.location.pathname.split('/')
        record_id = path_components[path_components.length - 1]

        let urlParams = new URLSearchParams(window.location.search);
        let highlight_file_names_in = urlParams.get('fn');
        let highlight_file_names = [];

        if (highlight_file_names_in && highlight_file_names_in.length > 0){
            highlight_file_names = highlight_file_names_in.split('___');
        }

        super(props);

        this.state = {
            record_id: record_id,
            record_details: null,
            highlight_file_names: highlight_file_names,
            basic_detail_tutorial: false,
        };

        this.fetchRecord = this.fetchRecord.bind(this);
        this.startTutorial = this.startTutorial.bind(this);
        this.processBasicTutorial = this.processBasicTutorial.bind(this);
    }

    componentDidMount() {
        trackEvent(EventNames.PAGE_LOAD, {data_1: 'oak_planning_detail', data_2: this.state.record_id} );

        basicAccountInfo()
        .then(
            data => {
                this.fetchRecord();
            }
        ).catch(error => {
            if (error?.name === 'LOGIN_ERROR') {
                this.props.history.push('/login');
            }
        });
    }

    fetchRecord() {

        if (!this.state.record_id){
            return;
        }

        var request = { 
            record_id: this.state.record_id,
        }

        generic_get_api(OAK_PLANNING_DETAIL, request)
        .then(
            data => { 
                this.setState({
                    record_details: data,
                }, this.startTutorial);
                window.scrollTo(0, 0);
            }
        )
        .catch(error => {
        });
    }

    startTutorial() {
        let basic_detail_tutorial = localStorage.getItem('basic_detail_tutorial');

        if (basic_detail_tutorial && basic_detail_tutorial.toLocaleLowerCase() === 'true'){
            this.setState({basic_detail_tutorial: true});
        }
    }

    processBasicTutorial(step_object) {

        if (step_object.status === 'finished') {
            
            localStorage.setItem('basic_detail_tutorial', 'false');
            this.setState({
                basic_detail_tutorial: false,
            });
        }
    }

    processInsightsTutorial(step_object) {

        if (step_object.status === 'finished') {
            
            localStorage.setItem('insights_tutorial', 'false');
            this.setState({
                insights_tutorial: false,
            });
        }
    }

    render() {

        const {record_details, highlight_file_names, basic_detail_tutorial, insights_tutorial} = this.state;

        return(
            <div class="container sfPlanningDetail">
                
                {
                    !record_details ? 
                        <LoadingPlaceholder />
                    :
                    <div class="container detailSection">
                        <div class="row">
                            <div class="col-8 projectDescription">
                                <div class="row">
                                    <div class="col">
                                        <div class="row">
                                            <div class="col fs-6 fw-bold">{record_details['record_number']}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="container mt-3">
                                    <div class="row fw-lighter">Application summary</div>
                                    <div class="row">{record_details['description']}
                                    </div>
                                </div>
                                <div class="container mt-3 ps-0">
                                    <div class="row fw-lighter">
                                        <div class="col">Parent application type</div>
                                        <div class="col">Parent application status</div>
                                        <div class="col">Application date</div>
                                    </div>
                                    <div class="row">
                                        <div class="col">{record_details['record_type']}</div>
                                        <div class="col">{record_details['current_status']}</div>
                                        <div class="col">{record_details['application_date']}</div>
                                    </div>
                                </div>
                                {
                                    (record_details.insight.received_opposition || record_details.insight.has_appeal) && 
                                    <div class="row mt-4">
                                    {
                                        record_details.insight.has_appeal  &&
                                        <div class="col-auto"><i class="fa-solid fa-check" style={{"color": "#164734"}}></i>&nbsp;<small>Appealed</small></div>
                                    }
                                    {
                                        record_details.insight.received_opposition &&
                                        <div class="col-auto"><i class="fa-solid fa-check" style={{"color": "#164734"}}></i>&nbsp;<small>Received opposition</small></div>
                                    }
                                    </div>
                                }
                            </div>

                            <div class="col-4 propertyInfoColumn">
                                { (record_details['address']['street_name'] && record_details['address']['street_name'].toLocaleLowerCase() !== 'public') &&
                                    <div class="container">
                                        <div class="row">{record_details['address']['street_number']} {record_details['address']['street_name']} {record_details['address']['street_suffix']}</div>
                                        <div class="row">Oakland {record_details['address']['postal']}</div>
                                    </div>
                                }
                                {
                                    (record_details['zone'] || record_details['gp_classification']) && 
                                    <div class="container mt-3">
                                        <div class="row fw-lighter">
                                            <div class="col ps-0">Zone</div>
                                            <div class="col">GP classification</div>
                                        </div>
                                        <div class="row">
                                            <div class="col ps-0"> {record_details['zone']}</div>
                                            <div class="col">{record_details['gp_classification']}</div>
                                        </div>
                                        
                                    </div>
                                }
                            </div>
                        </div>
                        
                        <InsightComponent insight={record_details['insight']}/>
                        <FileSection 
                            file_groups={record_details['file_groups']} 
                            highlight_file_names={highlight_file_names}
                        />

                    {   
                        record_details['related_records'] && record_details['related_records'].length > 0 &&
                        <>
                            <div class="row mt-5">
                                <div class="col fw-semibold text-success fs-6 subApplications"><i class="fa-regular fa-folder"></i>&nbsp;Sub applications</div>
                            </div>
                            <div class="row"><div class="col"><hr className="mt-1"></hr></div></div>
                            <div class="row mt-1">
                            {
                                record_details['related_records'].map(related_record => {
                                    return  <> 
                                                <RelatedRecordSection related_record={related_record} />
                                                <div class="row"><div class="col pe-5 ps-5"><hr></hr></div></div>
                                            </>
                                })
                            }
                            </div>
                        </>
                    }
                    </div>
                }
            </div>
        )
    }
}

function LoadingPlaceholder() {

    return(
            <div class="container detailSection">
                <div class="row">
                    <div class="col-8">
                        <div class="row">
                            <div class="col">
                                <div class="row ms-1">
                                    <Placeholder as="p" animation="glow">
                                        <Placeholder xs={4} bg="secondary"/>
                                    </Placeholder>
                                </div>
                                <div class="container mt-3 applicationSummary">
                                    <div class="row">
                                        <Placeholder as="p" animation="glow">
                                            <Placeholder xs={12} bg="secondary" size="lg"/>
                                            <Placeholder xs={12} bg="secondary" size="lg"/>
                                        </Placeholder>
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                        <div class="container mt-3 subApplications">
                        </div>
                        
                        <div class="container mt-3 availableFiles">
                            <div class="row">
                                <Placeholder as="p" animation="glow">
                                    <Placeholder xs={12} bg="secondary" size="lg"/>
                                    <Placeholder xs={12} bg="secondary" size="lg"/>
                                </Placeholder>
                            </div>
                        </div>
                            
                    </div>
                    <div class="col-4 propertyInfoColumn">
                        <div class="container">
                            <div class="row">
                                <Placeholder as="p" animation="glow">
                                    <Placeholder xs={12} bg="secondary"/>
                                    <Placeholder xs={12} bg="secondary"/>
                                </Placeholder>
                            </div>                           
                        </div>
                
                        <div class="container mt-3">
                            <div class="row">
                               
                            </div>
                        </div> 
                    </div>
                </div>
                <div class="container mt-4">
                    <div class="row">
                        <div class="col">
                            <Placeholder as="p" animation="glow">
                                <Placeholder xs={12} bg="secondary" size="lg"/>
                                <Placeholder xs={12} bg="secondary" size="lg"/>
                            </Placeholder>
                        </div>
                    </div>
                </div>
            </div>
    )
}

function FileSection(props) {
    const {file_groups, highlight_file_names} = props;
    const [expand_map, setExpandMap] = useState({});

    const toggleState = (class_name) => {
        setExpandMap(prevState => ({
            ...prevState,
            [class_name]: !expand_map[class_name],
        }));
    }

    const navigate = (signed_url, file_id, file_name) => {
        window.open(signed_url, '_blank');
        trackEvent(EventNames.VIEW_DETAIL_FILE, {data_1: file_id, data_2: file_name} );
    }

    if (!file_groups || file_groups.length == 0){
        return null;
    }

    return(
        <div class="">
            <div class="row mt-5">
                <div class="col fw-semibold text-success fs-6 fileSection"><i class="fa-regular fa-file-lines"></i>&nbsp;Available files &amp; documents</div>
            </div>
            <div class="row"><div class="col"><hr className="mt-1"></hr></div></div>
            {
                highlight_file_names && highlight_file_names.length > 0 &&
                <div class="row mt-1">
                    <div class="col">
                        Your keywords also matched these files: <span className="fw-bold text-primary">{highlight_file_names.join(', ')}</span></div>
                </div>

            }
            <div class="row mt-1">
                {file_groups.map(file_group => {
                    return  <div class="row mt-2  border p-2 ms-2">
                                <div class="row fw-bold">
                                    <div class="col">
                                        <a onClick={() => {toggleState(file_group.class_name)}} role="button">
                                            {
                                                expand_map[file_group.class_name] ?
                                                    <i class="fa-regular fa-square-minus fa-lg"></i>
                                                :
                                                <i class="fa-regular fa-square-plus fa-lg"></i>
                                            }
                                        
                                        </a>
                                        &nbsp;<a onClick={() => {toggleState(file_group.class_name)}} role="button">{file_group.class_name}</a>&nbsp;({file_group.files.length}) 
                                    </div>
                                </div>
                                {
                                    expand_map[file_group.class_name] &&
                                    <>
                                        {
                                            file_group.files.map(file => {
                                                return <div class="row mt-1 ms-4 fileEntry"><span><i class="fa-regular fa-file"></i>&nbsp;<a target="_blank" className="text-secondary" role="button" onClick={()=> navigate(file.signed_url, file.file_id, file.name)} href="#">{file.name}</a></span> </div>
                                            })
                                        }
                                    </>
                                }
                                
                            </div>
                })}
            </div>
        </div>
    )
}

function RelatedRecordSection(props) {

    const {related_record} = props;

    return(
        <div class="container">
            <div class="container">
                <div class="row fw-lighter">Application summary</div>
                <div class="row">{related_record['description']}</div>
            </div>
            <div class="container mt-3 ps-0">
                <div class="row fw-lighter">
                    <div class="col">Application number</div>
                    <div class="col">Application type</div>
                    <div class="col">Application status</div>
                    <div class="col">Application date</div>
                </div>
                <div class="row">
                    <div class="col">{related_record['record_number']}</div>
                    <div class="col">{related_record['record_type']}</div>
                    <div class="col">{related_record['current_status']}</div>
                    <div class="col">{related_record['application_date']}</div>
                </div>
            </div>
            {/* <div class="row">
                <div class="col">
                    {related_record['record_number']}&nbsp;&nbsp;&#x2022;&nbsp;&nbsp;
                    {related_record['record_type']}&nbsp;&nbsp;&#x2022;&nbsp;&nbsp;
                    {related_record['application_date']}&nbsp;&nbsp;&#x2022;&nbsp;&nbsp;
                    {related_record['current_status']}
                    
                </div>
            </div> */}
            {/* <div class="row mt-2">
                <div class="col-auto pe-0 text-primary"><i class="fa-regular fa-message"></i></div>
                <div class="col">{related_record['description']}</div>
            </div> */}
        </div>
    )
}

function InsightComponent(props) {

    const { insight } = props;

    const showInsights = () => {
        if (insight.show_time_line || insight.has_appeal || insight.received_opposition || 
            insight.approval_letter_insight) {
                return true;
            }
        return false;
    }

    if (!showInsights()){
        return null;
    }

    return (
        <div class="derivedSection mt-5">
           
            <div class="row">
                <div class="col fw-bold text-success fs-6"><i class="fa-solid fa-wand-magic-sparkles"></i>&nbsp;Insights</div>
            </div>
            <div class="row"><div class="col"><hr className="mt-1"></hr></div></div>
            
            {
                insight.show_time_line &&
                <div class="container">  
                    <div class="row mt-2">
                        <div class="col text-center fw-lighter">Application timeline</div>
                    </div>
                    <div class="row mb-5 mt-4">
                        <TimeLine
                            time_line={insight['time_line']}
                        />
                    </div>
                </div>
            }
            
            <ApprovalLetterInsightComponent approval_insight={insight['approval_letter_insight']} />
        </div>
    )
}

function ApprovalLetterInsightComponent(props) {
    const {approval_insight} = props;

    if (!approval_insight){
        return null;
    }

    return (
        <div class="row zadInsight border rounded mt-4 ms-1 p-2">
            <div class="row  fw-bold fs-6"><div class="col">Decision letter insights</div></div>

            <div class="container mt-3">
                <div class="row fw-lighter">
                    <div class="col">Document date</div>
                    <div class="col">Decision</div>
                </div>
                <div class="row">
                    <div class="col">
                    {
                        approval_insight.document_date ? 
                        <>{approval_insight['document_date']}</> :<>N/A</> 
                    }
                    </div>
                    <div class="col">
                    {
                        approval_insight.decision ? 
                        <>{approval_insight['decision']}</> :<>N/A</> 
                    }
                    </div>
                </div>
            </div>
            <div class="container mt-3">
                <div class="row fw-lighter"><div class="col">Proposal</div></div>
                <div class="row"><div class="col">{approval_insight['proposal']}</div></div>
            </div>
            <div class="container mt-3">
                <div class="row fw-lighter"><div class="col">Environmental determination</div></div>
                <div class="row"><div class="col">{approval_insight['environmental_determination']}</div></div>
            </div>
            <div class="container mt-3">
                <div class="row fw-lighter"><div class="col">Historical status</div></div>
                <div class="row"><div class="col">{approval_insight['historic_status']}</div></div>
            </div>
            <div class="container mt-3">
                <div class="row fw-lighter"><div class="col">Findings</div></div>
                <div class="row"><div class="col">{approval_insight['findings']}</div></div>
            </div>
        </div>
    )
}

function TimeLine(props) {
    const {time_line} = props;
    const [split_time_line, setSplitTimeLine] = useState([]);

    useEffect(() => {
        let middle = Math.floor(time_line.length / 2);

        let list_1 = [];
        let list_2 = [];

        let i = 0;
        for(i; i < time_line.length; i++){
            if (i < middle) {
                list_1.push(time_line[i]);
            }
            else{
                list_2.push(time_line[i]);
            }
        }

        setSplitTimeLine([list_1, list_2]);
    }, [time_line]);

    if (time_line.length <= 0){
        return null;
    }


    return (                                            
        <>
            {
                time_line.length <= 7 &&
                <div class="container d-flex justify-content-center timeLine">
                    <div class="row">
                        <div class="col">
                            <div class="row text-center"><div class="col p-0 text-wrap width85"><small>{time_line[0][0]}</small></div></div>
                            <div class="row mt-1 mb-1"><div class="col p-0"><img src={left_line}/></div></div>
                            <div class="row text-center"><div class="col p-0"><small>{time_line[0][1]}</small></div></div>
                        </div>
                        {
                            time_line.map((entry, index) => {
                                if (index > 0 && index < time_line.length - 1){
                                    return  <div class="col">
                                                <div class="row text-center"><div class="col p-0 text-wrap width85"><small>{entry[0]}</small></div></div>
                                                <div class="row  mt-1 mb-1"><div class="col p-0"><img src={middle_line}/></div></div>
                                                <div class="row text-center"><div class="col p-0"><small>{entry[1]}</small></div></div>
                                            </div>
                                }
                                    
                            })
                        }
                        <div class="col">
                            <div class="row text-center text-wrap"><div class="col p-0 width85"><small>{time_line[time_line.length - 1][0]}</small></div></div>
                            <div class="row mt-1 mb-1"><div class="col p-0"><img src={right_line}/></div></div>
                            <div class="row text-center"><div class="col p-0"><small>{time_line[time_line.length - 1][1]}</small></div></div>
                        </div>
                    </div>
                </div>
            }
            {
                time_line.length > 7 && time_line.length <= 14 && split_time_line.length === 2 &&
                <>
                    <div class="container d-flex justify-content-center timeLine">
                        <div class="row">
                            <div class="col">
                                <div class="row text-center"><div class="col p-0 text-wrap width85"><small>{split_time_line[0][0][0]}</small></div></div>
                                <div class="row mt-1 mb-1"><div class="col p-0"><img src={left_line}/></div></div>
                                <div class="row text-center"><div class="col p-0"><small>{split_time_line[0][0][1]}</small></div></div>
                            </div>
                            {
                                split_time_line[0].map((entry, index) => {
                                    if (index > 0 && index < split_time_line[0].length - 1){
                                        return  <div class="col">
                                                    <div class="row text-center"><div class="col p-0 text-wrap width85"><small>{entry[0]}</small></div></div>
                                                    <div class="row  mt-1 mb-1"><div class="col p-0"><img src={middle_line}/></div></div>
                                                    <div class="row text-center"><div class="col p-0"><small>{entry[1]}</small></div></div>
                                                </div>
                                    }
                                        
                                })
                            }
                            <div class="col">
                                <div class="row text-center text-wrap"><div class="col p-0 width85"><small>{split_time_line[0][split_time_line[0].length - 1][0]}</small></div></div>
                                <div class="row mt-1 mb-1"><div class="col p-0"><img src={middle_line}/></div></div>
                                <div class="row text-center"><div class="col p-0"><small>{split_time_line[0][split_time_line[0].length - 1][1]}</small></div></div>
                            </div>
                        </div>
                    </div>
                    {/* second row */}
                    <div class="container d-flex justify-content-center timeLine">
                    <div class="row mt-5">
                        <div class="col">
                            <div class="row text-center"><div class="col p-0 text-wrap width85"><small>{split_time_line[1][0][0]}</small></div></div>
                            <div class="row mt-1 mb-1"><div class="col p-0"><img src={middle_line}/></div></div>
                            <div class="row text-center"><div class="col p-0"><small>{split_time_line[1][0][1]}</small></div></div>
                        </div>
                        {
                            split_time_line[1].map((entry, index) => {
                                if (index > 0 && index < split_time_line[1].length - 1){
                                    return  <div class="col">
                                                <div class="row text-center"><div class="col p-0 text-wrap width85"><small>{entry[0]}</small></div></div>
                                                <div class="row  mt-1 mb-1"><div class="col p-0"><img src={middle_line}/></div></div>
                                                <div class="row text-center"><div class="col p-0"><small>{entry[1]}</small></div></div>
                                            </div>
                                }
                                    
                            })
                        }
                        <div class="col">
                            <div class="row text-center text-wrap"><div class="col p-0 width85"><small>{split_time_line[1][split_time_line[1].length - 1][0]}</small></div></div>
                            <div class="row mt-1 mb-1"><div class="col p-0"><img src={right_line}/></div></div>
                            <div class="row text-center"><div class="col p-0"><small>{split_time_line[1][split_time_line[1].length - 1][1]}</small></div></div>
                        </div>
                    </div>
                    </div>
                </>
                
                
            }
          </> );
}

export default OakPlanningDetail;